import { UtilService } from "./../../../_global/util.service";
import {
    Component,
    OnInit,
    OnDestroy,
    ViewEncapsulation,
    AfterViewInit,
} from "@angular/core";
import { GlobalService } from "../../../_global/global.service";
import { PartnerResponseModel } from "../../../_models/partner/PartnerResponseModel";
import { LoginService } from "../../../_services";
import { Router, NavigationEnd } from "@angular/router";
import { Subscription } from "rxjs/Subscription";

declare let mLayout: any;
@Component({
    selector: "app-header-nav",
    templateUrl: "./header-nav.component.html",
    styleUrls: ["./header-nav.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class HeaderNavComponent implements OnInit, AfterViewInit, OnDestroy {
    public showFxCalculator;
    public bulkOrderAllowed;
    public uipermissionList = new Array<any>();
    public cdpUipermissionList = new Array<any>();

    public partnerList = new PartnerResponseModel();
    public userName: any = "";
    isTourAgent: boolean = false;
    showPGLeads: boolean = false;
    showLeads: boolean = false;
    showUserMapping: boolean = false;
    API_URL: string;
    // Mobile / tablet (< 992px) navigation drawer
    isMobileMenuOpen = false;
    private _routerSub: Subscription;

    constructor(
        public _gs: GlobalService,
        public _util: UtilService,
        public _router: Router,
        public _loginService: LoginService,
    ) {
        var cdpRole = sessionStorage.getItem("cdpRole");
        var cdpDepartment = sessionStorage.getItem("cdpDepartment");

        if (
            (cdpRole == "ADMIN" && cdpDepartment == "CARD_DEPT") ||
            cdpDepartment == "PRODUCT"
        ) {
            this.showUserMapping = true;
        }
    }

    ngOnInit() {
        // Auto-close the mobile drawer on navigation
        this._routerSub = this._router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.closeMobileMenu();
            }
        });
        console.log("this._gs.currentUser_+", this._gs.currentUser);
        if (this._gs.currentUser.partner.partnerType == "TOUR_AGENT") {
            this.isTourAgent = true;
        }
        this.API_URL = this._loginService.API_URL;
        this.userName =
            (this._gs.currentUser.firstName == null
                ? ""
                : this._gs.currentUser.firstName) +
            " " +
            (this._gs.currentUser.lastName == null
                ? ""
                : this._gs.currentUser.lastName);
        this.showFxCalculator = sessionStorage.getItem("showFxCalculator");
        this.bulkOrderAllowed = sessionStorage.getItem("bulkOrderAllowed");
        this.uipermissionList = this._gs.currentUser.uiPermissions;
        this.cdpUipermissionList = this._gs.currentUser.cpdUiPermissions;
        if (
            this.uipermissionList.includes("LEAD_CREATE_SPECIAL") &&
            this.uipermissionList.includes("LEAD_CREATE")
        ) {
            this.showPGLeads = true;
            this.showLeads = true;
        } else if (
            !this.uipermissionList.includes("LEAD_CREATE_SPECIAL") &&
            this.uipermissionList.includes("LEAD_CREATE")
        ) {
            this.showPGLeads = false;
            this.showLeads = true;
        } else if (
            this.uipermissionList.includes("LEAD_CREATE_SPECIAL") &&
            !this.uipermissionList.includes("LEAD_CREATE")
        ) {
            this.showPGLeads = true;
            this.showLeads = false;
        } else if (
            !this.uipermissionList.includes("LEAD_CREATE_SPECIAL") &&
            !this.uipermissionList.includes("LEAD_CREATE")
        ) {
            this.showPGLeads = false;
            this.showLeads = false;
        }
    }

    ngAfterViewInit() {
        mLayout.initHeader();
        this.initMobileSubmenus();
        this.initSmartSubmenuFlip();
    }

    ngOnDestroy() {
        if (this._routerSub) {
            this._routerSub.unsubscribe();
        }
        document.body.style.overflow = "";
    }

    toggleMobileMenu(): void {
        this.isMobileMenuOpen = !this.isMobileMenuOpen;
        // Lock page scroll while the drawer is open
        document.body.style.overflow = this.isMobileMenuOpen ? "hidden" : "";
    }

    closeMobileMenu(): void {
        this.isMobileMenuOpen = false;
        document.body.style.overflow = "";
    }

    // Accordion submenus inside the mobile drawer (one open per level)
    private initMobileSubmenus(): void {
        const menu = document.getElementById("m_header_menu");
        if (!menu) {
            return;
        }
        menu.addEventListener("click", (event: Event) => {
            if (window.innerWidth >= 992) {
                return;
            }
            const toggleLink = (event.target as Element).closest(".m-menu__toggle");
            if (!toggleLink) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            const item = toggleLink.closest(".m-menu__item--submenu") as HTMLElement;
            if (!item || !item.parentElement) {
                return;
            }
            const isOpen = item.classList.contains("mobile-open");
            const siblings = item.parentElement.children;
            for (let i = 0; i < siblings.length; i++) {
                siblings[i].classList.remove("mobile-open");
            }
            if (!isOpen) {
                item.classList.add("mobile-open");
            }
        });
    }

    // Keeps desktop dropdowns and fly-outs inside the viewport near the right edge
    private initSmartSubmenuFlip(): void {
        const menu = document.getElementById("m_header_menu");
        if (!menu) {
            return;
        }
        const items = menu.querySelectorAll(".m-menu__item--submenu");
        for (let i = 0; i < items.length; i++) {
            const item = items[i] as HTMLElement;
            item.addEventListener("mouseenter", () => {
                if (window.innerWidth < 992) {
                    return;
                }
                const rect = item.getBoundingClientRect();
                const vw = window.innerWidth;
                const isTopLevel =
                    item.parentElement &&
                    item.parentElement.classList.contains("m-menu__nav");
                if (isTopLevel) {
                    item.classList.toggle("submenu-align-right", rect.left + 280 > vw - 10);
                } else {
                    item.classList.toggle("submenu-flyout-left", rect.right + 260 > vw - 10);
                }
            });
        }
    }

    goToAMLDashboard() {
        this._router.navigate(["/admin/aml-dashboard"]);
    }

    goToIDFCBulkUpload() {
        this._router.navigate(["/admin/idfc-bulk-upload"]);
    }
    placeWalkinOrder(isWalkin) {
        this.closeMobileMenu();
        this._router.navigate(["/quick/walkinorderplace"], {
            queryParams: { isWalkin: isWalkin },
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/layouts/header-nav/header-nav.component.ts